import { render, staticRenderFns } from "./SupplierSales.vue?vue&type=template&id=4e4cbcec&lang=pug&"
import script from "./SupplierSales.vue?vue&type=script&lang=ts&"
export * from "./SupplierSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports